
import { Component, Vue, Watch } from 'vue-property-decorator';
import actions from '@/shared/actions';
import Topbar from '@/components/topbar/index.vue';
import AppUserBar from '@/components/appUserBar/index.vue';

@Component({
  components: {
    Topbar,
    AppUserBar
  }
})
export default class App extends Vue {
  private showTopbar: boolean = false;
  private isHome: boolean = false;
  private watermarkText: string = '';
  private isNewThemeApp: boolean = false;

  private isShowMistoreTheme: boolean = false;

  private globalTheme: string = '';

  @Watch('$route', { immediate: true, deep: true })
  onRouteNameChange(newVal: any /** Route */) {
    this.showTopbar = newVal.path !== '/login';
    this.isHome = newVal.path === '/';
    console.log(newVal);
    this.isNewThemeApp = !newVal.path.includes('main-taskcenter')

    this.isShowMistoreTheme = newVal.path.includes('main-mistore');

    if (this.isShowMistoreTheme) {
      this.globalTheme = 'qk-newtheme qk-global-theme';
    } else if (this.isNewThemeApp) {
      this.globalTheme = 'qk-newtheme';
    } else {
      this.globalTheme = '';
    }
  }

  mounted() {
    actions.onGlobalStateChange((state) => {
      if (state.userInfo) {
        this.watermarkText = `${state.userInfo.userName}  ${state.userInfo.mobile.slice(-4)}`;
      }
    }, true);
  }
}
